import script from "./ConfigParkSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigParkSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigParkSection.vue?vue&type=style&index=0&id=5be6b3fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be6b3fd"]])

export default __exports__